import React, { Fragment, useEffect, useState, useRef } from "react";
import { utilService } from "../../../../services";
import sanitizeHtml from "sanitize-html";
import { VideoService } from "./VideoComponent.service";
import "./VideoComponent.scss";
import { dataTransferService } from "../../../../services/dataTransferService";
import { doctorsListService } from "../../../../components/Shared/DoctorList/doctor-list-service";

import {
  MediaCapture,
  MediaFile,
  CaptureVideoOptions,
} from "@ionic-native/media-capture";

import { Capacitor } from "@capacitor/core";
import { File as ionicFile } from "@ionic-native/file";
import _ from "lodash";
import { CONSTANTS } from "../../../../constants/callcentral.constants";
import { useToast } from "@agney/ir-toast";

declare const Recorder: any;
declare const MediaRecorder: any;

interface VideoComponentProps {
  onComplete: () => void;
  selectedDoctorData: object;
  isStatusBoard?: boolean;
  smsThread?: any;
  isFromEMT?: any;
}

const VideoComponent: React.FC<VideoComponentProps> = (props) => {
  const recordedBlobsRef = useRef<Blob[]>([]);

  const [mediaSource, setMediaSource]: any = useState();
  const [sourceBuffer, setSourceBuffer]: any = useState();
  const [gumVideo, setGumVideo]: any = useState();
  const [mediaRecorder, setMediaRecorder]: any = useState();

  const [isWeb, setIsWeb]: any = useState(false);
  const [recordedVideo, setRecordedVideo]: any = useState({});
  const [isVideoRecording, setIsVideoRecording] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [timerIntervalID, setTimerIntervalID]: any = useState("");
  const [isVideoDeviceAvailable, setIsVideoDeviceAvailable] = useState(true);
  const Toast = useToast();
  useEffect(() => {
    checkIfSmallScreen();
    if (utilService.isWeb()) {
      setIsWeb(true);
      setVideoDeviceStatus();
    }
    return () => {
      makeWebCamOff();
    };
  }, []);

  // useEffect(() => {
  //   if (!_.isEmpty(gumVideo)) {
  //     startRecord();
  //   }
  // }, [gumVideo]);

  useEffect(() => {
    if (mediaSource) {
      if (utilService.isWeb()) {
        mediaSource.addEventListener("sourceopen", handleSourceOpen, false);
        const gumVideo = document.querySelector("video#gum");
        setGumVideo(gumVideo);
        setupVideoRecorder();
      }
    }
  }, [mediaSource]);

  useEffect(() => {
    let sub = dataTransferService.getVideoMediaAction.subscribe((data: any) => {
      if (data === true) {
        startRecord();
      } else {
        stopRecord();
      }
    });
    return () => {
      sub.unsubscribe();
    };
  });

  useEffect(() => {
    if (utilService.isWeb()) {
      const mediaSource = new MediaSource();
      setMediaSource(mediaSource);
    }
  }, []);

  // useEffect(() => {
  //   if (mediaRecorder) {
  //     startRecord();
  //   }
  // }, [mediaRecorder]);


  const startRecord = () => {
    if (utilService.isWeb()) {
      webStartRecord();
    } else {
      nativeStartRecord();
    }
  };

  const stopRecord = () => {
    if (utilService.isWeb()) {
      webStopRecord();
    } else {
    }
  };

  const checkIfSmallScreen = () => {
    if (utilService.getScreenSize() === "small") {
      setIsSmallScreen(true);
      let footerPermission = !props.isFromEMT
        ? utilService.hideFooterTab()
        : "";
    } else {
      setIsSmallScreen(false);
    }
  };

  const handleSourceOpen = () => {
    console.log("MediaSource opened");
    const sourceBuffer = mediaSource.addSourceBuffer(
      'video/webm; codecs="vp8"'
    );
    setSourceBuffer(sourceBuffer);
    console.log("Source buffer: ", sourceBuffer);
  };

const setupVideoRecorder = () => {
  var options = { mimeType: "video/webm", bitsPerSecond: 100000 };

  var constraints = {
    audio: true,
    video: true,
  };

  navigator.mediaDevices
    .getUserMedia(constraints)
    .then(function (stream) {
      (window as any).stream = stream;

      const mediaRecorder = new MediaRecorder(stream, options);

      // ✅ FIX: onstop → save video
      mediaRecorder.onstop = () => {
        play();
      };

      // ✅ FIX: useRef instead of state
      mediaRecorder.ondataavailable = (event: any) => {
        if (event.data && event.data.size > 0) {
          recordedBlobsRef.current.push(event.data);
        }
      };

      setMediaRecorder(mediaRecorder);

      const gumVideo: any = document.querySelector("video#gum");
      VideoService.gumVideo = gumVideo;
      setGumVideo(gumVideo);

      if ("srcObject" in gumVideo) {
        gumVideo.srcObject = stream;
      } else {
        gumVideo.src = window.URL.createObjectURL(stream);
      }

      gumVideo.onloadedmetadata = function () {
        gumVideo.play();
      };
    })
    .catch(function (error) {
      console.log("navigator.getUserMedia error: ", error);
    });
};

  const nativeStartRecord = async () => {
    let options: CaptureVideoOptions = { limit: 1, duration: 30 };
    let capture: any = await MediaCapture.captureVideo(options);
    if (capture.length > 0) {
      copyFileToLocalDir(capture[0].fullPath);
    }
    console.log((capture[0] as MediaFile).fullPath);
  };

  const copyFileToLocalDir = async (fullPath: any) => {
    const name = fullPath.substr(fullPath.lastIndexOf("/") + 1);
    let resolvedPath: any;
    let path = fullPath.substring(0, fullPath.lastIndexOf("/"));
    if (Capacitor.getPlatform() === "ios") {
      resolvedPath = await ionicFile.resolveDirectoryUrl("file://" + path);
    } else {
      resolvedPath = await ionicFile.resolveDirectoryUrl(path);
    }
    readAsArrayBuffer(resolvedPath, name);
  };

  const readAsArrayBuffer = (resolvedPath: any, name: any) => {
    return ionicFile.readAsArrayBuffer(resolvedPath.nativeURL, name).then(
      (buffer: any) => {
        const fileExtension = name.match(/\.[A-z0-9]+$/i)[0].slice(1);
        // get the buffer and make a blob to be saved
        let blob = new Blob([buffer], {
          type: `video/${fileExtension}`,
        });
        setFileData(blob, resolvedPath.nativeURL, name, fileExtension);
      },
      (error: any) => console.log(error)
    );
  };

  const setFileData = (Blob: any, path: any, name: any, extn: any) => {
    const fileData = blobToFile(Blob, name);
    const filePath = path + name;
    setNativeParams(fileData, filePath, extn);
  };

const webStartRecord = () => {
  if (!isVideoDeviceAvailable) {
    showVideoErrorMessage();
    return;
  }

  recordedBlobsRef.current = []; // ✅ reset properly
  setIsVideoRecording(true);

  if (mediaRecorder) {
    mediaRecorder.start(100);
    startVideoTimer();
  }
};

const webStopRecord = () => {
  if (mediaRecorder && isVideoRecording) {
    mediaRecorder.stop();
    setIsVideoRecording(false);
    clearInterval(timerIntervalID);
  }
};

const play = () => {
  if (!recordedBlobsRef.current.length) {
    console.log("No video data recorded");
    return;
  }

  const superBuffer = new Blob(recordedBlobsRef.current, {
    type: "video/webm",
  });

  const url = URL.createObjectURL(superBuffer);

  const fileData = blobToFile(superBuffer, "vid.webm");

  const recordedVideo = {
    name: "VID_" + new Date().toISOString(),
    type: 3,
    nativeURL: url,
    size: utilService.formatBytes(superBuffer.size),
    file: fileData,
  };

  setRecordedVideo(recordedVideo);
  setWebParams(fileData, recordedVideo);

  makeWebCamOff();
};

  const makeWebCamOff = () => {
    if (utilService.isWeb()) {
      VideoService.gumVideo.pause();
      VideoService.gumVideo.src = "";
      VideoService.gumVideo.srcObject
        .getTracks()
        .forEach(function (track: any) {
          if (track.readyState === "live") {
            track.stop();
          }
        });
    }
  };

  const blobToFile = (theBlob: any, fileName: string): any => {
    var b: any = theBlob;
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;
    // b.__proto__ = File.prototype;

    //Cast to a File() type
    return theBlob as any;
  };

  const mapToGuidData = () => {
    if (props.isStatusBoard) {
      var initialArray = [];
      initialArray.push(utilService.getLoggedUserGuid());
      return JSON.stringify(initialArray);
    } else {
      return JSON.stringify(
        doctorsListService.getSelectedUsersList(props.selectedDoctorData)
      );
    }
  };

  const setWebParams = (fileData: any, recordedVideo: any) => {
    let clientMediaID = Math.floor(Math.random() * 10000);
    recordedVideo.clientMediaID = clientMediaID;
    const params = {
      clientMediaID: clientMediaID,
      from_guid: utilService.getLoggedUserGuid(),
      to_guid: mapToGuidData(),
      message: "",
      type: 3,
      action: 1,
      sms_thread_id: props.smsThread ? props.smsThread : null,
      name:
        "VID-" + new Date().getMinutes() + new Date().getSeconds() + ".webm",
      file: fileData,
      size: utilService.formatBytes(fileData.size),
    };
    VideoService.displayVideoList.push(recordedVideo);
    VideoService.uploadVideoList.push(params);
    props.onComplete();
  };

  const setNativeParams = (fileData: any, filePath: any, extn: any) => {
    let clientMediaID = Math.floor(Math.random() * 10000);
    const serverParams = {
      clientMediaID: clientMediaID,
      from_guid: utilService.getLoggedUserGuid(),
      to_guid: mapToGuidData(),
      message: "",
      type: 3,
      action: 1,
      sms_thread_id: props.smsThread ? props.smsThread : null,
      name: filePath.substr(filePath.lastIndexOf("/") + 1),
      file: fileData,
      size: utilService.formatBytes(fileData.size),
    };
    const localParams = {
      clientMediaID: clientMediaID,
      type: 3,
      name: filePath.substr(filePath.lastIndexOf("/") + 1),
      nativeURL: filePath,
      size: utilService.formatBytes(fileData.size),
    };
    VideoService.displayVideoList.push(localParams);
    VideoService.uploadVideoList.push(serverParams);
    props.onComplete();
  };

  const onVideoRecBtnClick = () => {
    setIsVideoRecording(!isVideoRecording);
    if (!isSmallScreen) {
      setVideoRecordCss(!isVideoRecording);
      startVideoTimer();
    }
  };

  const startVideoTimer = () => {
    const minsEle: any = document.querySelector(".minsVideo");
    const secEle: any = document.querySelector(".secVideo");
    showTimerinUI(minsEle, secEle);
  };

  const showTimerinUI = (minute: any, seconds: any) => {
    const startTime: any = new Date();
    let duration = 0;
    let stopTime = 0;
    const timer: any = setInterval(() => {
      let currTime: any = new Date();
      duration = stopTime + (currTime - startTime) / 1000;
      minute.innerHTML = (duration / 60) << 0;
      seconds.innerHTML = duration % 60 << 0;
    }, 10);

    setTimerIntervalID(timer);
  };

  const setVideoRecordCss = (status: Boolean) => {
    const recDiv: any = document.getElementById("recVideoButton");
    showRecordForMedia(recDiv, status);
  };

  const showRecordForMedia = (recordDiv: any, status: any) => {
    recordDiv.classList.add("notRec");
    if (status) {
      recordDiv.classList.add("Rec");
    } else {
      recordDiv.classList.add("notRec");
      recordDiv.classList.remove("Rec");
    }
  };

  const showVideoErrorMessage = () => {
    Toast.error(CONSTANTS.MESSAGES.NO_VIDEO_DEVICE);
  };

  const setVideoDeviceStatus = () => {
    var localVideoStream: any;
    navigator.mediaDevices.getUserMedia(
      { video: true })
      .then(function (stream) {
        setIsVideoDeviceAvailable(true);
        localVideoStream = stream;
        stream.getTracks().forEach((track) => track.stop());
      })
      .catch(function (error) {
        setIsVideoDeviceAvailable(false);
      }
    );

    if (localVideoStream) {
      localVideoStream.getTracks().forEach((track: any) => track.stop());
    }
  };

  return (
    <div className="video-comp-container">
      {isWeb && (
        <Fragment>
          <div className="live-cam-div">
            <video id="gum" playsInline></video>
          </div>
          <div className="record-video-container">
            <div
             className="rec-button-wrapper clickable"
            >
              <div
                className="rec-btn-div"
             onClick={() => {
  if (isVideoRecording) {
    webStopRecord();
  } else {
    webStartRecord();
  }
}}
                title="Stop Recording"
              >
                <button id="recVideoButton"></button>
              </div>

              <div className="timer-div">
                <span className="minsVideo">0</span>
                <span className="divider">:</span>
                <span className="secVideo">0</span>
              </div>
            </div>
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default VideoComponent;
